import { __awaiter, __decorate, __extends, __generator } from "tslib";
import NavPanel from '@/components/common/NavPanel.vue';
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/invite/import';
import AvalonGTGlobal from '@/utils/factory/Global';
import moment from 'moment';
import { Toast } from 'vant';
import { gsap } from 'gsap';
var HuanxunExportReport = /** @class */ (function (_super) {
    __extends(HuanxunExportReport, _super);
    function HuanxunExportReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportList = [];
        _this.deriveLoading = false;
        _this.params = {};
        _this.downloadUrl = '';
        _this.calendarShow = false;
        _this.tiemr = '';
        /** range=自定义时间；single=按日 */
        _this.iscalendarType = 'range';
        _this.singleTiem = '';
        return _this;
    }
    HuanxunExportReport.prototype.mounted = function () {
        this.params = this.$route.query;
        this.params.startDate = moment().subtract(38, 'day').format('YYYY-MM-DD');
        this.params.endDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
        this.params.minDate = new Date(this.params.startDate);
        this.params.maxDate = new Date(this.params.endDate);
        this.singleTiem = this.params.startDate;
        this.getList();
    };
    HuanxunExportReport.prototype.beforeDestroy = function () {
        clearTimeout(this.tiemr);
    };
    HuanxunExportReport.prototype.formatDisplayDate = function (val) {
        if (!val)
            return '';
        return moment(val).format('YYYY年M月D日');
    };
    HuanxunExportReport.prototype.linkService = function () {
        this.awlGlobalConfig.gotoKfService();
    };
    // 刷新逻辑保留，模板已注释入口
    HuanxunExportReport.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.deriveLoading)
                            return [2 /*return*/, Toast('导出中...')];
                        gsap.fromTo('.hx-export-refresh', { rotation: 0 }, { rotation: 360, duration: 5, ease: 'elastic' });
                        return [4 /*yield*/, this.getList()];
                    case 1:
                        _a.sent();
                        Toast('刷新成功~');
                        return [2 /*return*/];
                }
            });
        });
    };
    HuanxunExportReport.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.exportRecord({})];
                    case 1:
                        data = _a.sent();
                        this.reportList = data.list;
                        return [2 /*return*/];
                }
            });
        });
    };
    HuanxunExportReport.prototype.getDownloadUrl = function () {
        var _this = this;
        if (this.deriveLoading)
            return Toast('导出中...');
        this.deriveLoading = true;
        var params = {
            startDate: this.params.startDate,
            endDate: this.params.endDate,
        };
        if (this.iscalendarType === 'single') {
            params.startDate = this.singleTiem;
            params.endDate = this.singleTiem;
        }
        PageService.exportInviteExcel(params)
            .then(function () {
            _this.getList();
            _this.tiemr = setTimeout(function () {
                _this.getList();
                _this.deriveLoading = false;
            }, 3000);
        })
            .catch(function () {
            _this.deriveLoading = false;
        });
    };
    HuanxunExportReport.prototype.dateShowHandle = function () {
        this.calendarShow = true;
    };
    HuanxunExportReport.prototype.onCalendarConfirm = function (values) {
        if (this.iscalendarType === 'range') {
            this.params.startDate = moment(values[0]).format('YYYY-MM-DD');
            this.params.endDate = moment(values[1]).format('YYYY-MM-DD');
        }
        else {
            this.singleTiem = moment(values).format('YYYY-MM-DD');
        }
        this.calendarShow = false;
    };
    HuanxunExportReport.prototype.copyHandle = function (val) {
        AvalonGTGlobal.copyText(val);
    };
    HuanxunExportReport = __decorate([
        Options({
            name: 'HuanxunExportReport',
            components: { NavPanel: NavPanel },
        })
    ], HuanxunExportReport);
    return HuanxunExportReport;
}(AvalonGTView.BaseView));
export default HuanxunExportReport;
